export class BusMapConstants {
  static readonly DefaultLatitudeARN = 59.646507;
  static readonly DefaultLongitudeARN = 17.942503;
  static readonly DefaultZoomLevel = 14;

  static readonly UnknownBusNumber = "Okänd";
  static readonly AvailabilitySkillAirside = "AIR";
  static readonly AvailabilitySkillLandside = "LAND";
  static readonly StateMachineActiveStatus = "ACTIVE";

  static readonly MarkerAirsideImageName = '/assets/images/maps/airside_active.png';
  static readonly MarkerAirsideInactiveImageName = '/assets/images/maps/airside_inactive.png';
  static readonly MarkerLandsideImageName = '/assets/images/maps/landside_active.png';
  static readonly MarkerLandsideInactiveImageName = '/assets/images/maps/landside_inactive.png';
  static readonly MarkerInactiveTimeout = 10;
  static readonly MarkerUnknownActiveImageName = '/assets/images/unknown-active-icon.png';
  static readonly MarkerUnknownInactiveImageName = '/assets/images/unknown-inactive-icon.png'; 

}
